/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Not_In_SetupInputs */

const en_issue_not_in_setup = /** @type {(inputs: Issue_Not_In_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`priced on a price list or currency the Price Setup no longer has`)
};

/**
* | output |
* | --- |
* | "priced on a price list or currency the Price Setup no longer has" |
*
* @param {Issue_Not_In_SetupInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_not_in_setup = /** @type {((inputs?: Issue_Not_In_SetupInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Not_In_SetupInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_not_in_setup(inputs)
});